import { ListFilter } from 'pages/Chat/types';

import { SelectableFilters } from './types';

export const selectableFilters: SelectableFilters[] = [
  {
    listFilter: null,
    label: 'MESSAGETIPS.GLOBALCHAT.FILTERALL',
  },
  {
    listFilter: ListFilter.UNREAD_ONLY,
    label: 'MESSAGETIPS.GLOBALCHAT.NEWS',
  },
  {
    listFilter: ListFilter.SCHEDULED_MESSAGES_ONLY,
    label: 'MESSAGETIPS.GLOBALCHAT.SCHEDULED',
  },
];
